module.exports = __webpack_public_path__ + "static/media/logo.7b1cdc1e.jpg";